export default __webpack_public_path__ + "static/te-_medium_1-e9df9c3f0ed08424debf5d551bb20622.png";